import { render } from "./FloatShowComponent.vue?vue&type=template&id=2dfb5e38"
import script from "./FloatShowComponent.vue?vue&type=script&lang=js"
export * from "./FloatShowComponent.vue?vue&type=script&lang=js"

import "./FloatShowComponent.vue?vue&type=style&index=0&id=2dfb5e38&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__